var React = require('react');

function LeftArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M7.55887 15.5833C7.3908 15.5839 7.22474 15.5481 7.07289 15.4788C6.92104 15.4094 6.78726 15.3082 6.68137 15.1825L1.24762 8.68247C1.08216 8.48863 0.991699 8.24548 0.991699 7.99456C0.991699 7.74363 1.08216 7.50048 1.24762 7.30664L6.87262 0.80664C7.06358 0.585405 7.33798 0.446279 7.63546 0.419867C7.93294 0.393456 8.22913 0.481923 8.45887 0.665806C8.68862 0.84969 8.83309 1.11393 8.86052 1.40039C8.88795 1.68685 8.79608 1.97207 8.60512 2.19331L3.57637 7.99997L8.43637 13.8066C8.57394 13.9657 8.66133 14.1593 8.68819 14.3646C8.71506 14.57 8.68028 14.7784 8.58796 14.9653C8.49565 15.1523 8.34967 15.3098 8.1673 15.4193C7.98492 15.5288 7.77379 15.5857 7.55887 15.5833Z","fill":"white"}));
}

LeftArrow.defaultProps = {"width":"9","height":"16","viewBox":"0 0 9 16","fill":"none"};

module.exports = LeftArrow;

LeftArrow.default = LeftArrow;
